export const GET_SYSTEM_PARAMETERS = 'GET_SYSTEM_PARAMETERS';
export const GET_SYSTEM_PARAMETERS_SUCCESS = 'GET_SYSTEM_PARAMETERS_SUCCESS';
export const GET_SYSTEM_PARAMETERS_FAILED = 'GET_SYSTEM_PARAMETERS_FAILED';
export const SYSTEM_PARAMETERS_NOT_FOUND = 'SYSTEM_PARAMETERS_NOT_FOUND';

export const SAVE_SYSTEM_PARAMETERS = 'SAVE_SYSTEM_PARAMETERS';
export const SAVE_SYSTEM_PARAMETERS_SUCCESS = 'SAVE_SYSTEM_PARAMETERS_SUCCESS';
export const SAVE_SYSTEM_PARAMETERS_FAILED = 'SAVE_SYSTEM_PARAMETERS_FAILED';
